// src/index.tsx


import React from 'react';
import ReactDOM from 'react-dom/client'; // Burada import değişti
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
// React 18'de createRoot kullanılması gerektiği için yeni API ile render işlemi yapılır
const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
